import React, { useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { Layout, Image, Typography } from 'antd';
import { ArrowRightOutlined } from '@ant-design/icons';
import axios from 'axios';

const { Content } = Layout;
const { Title, Text } = Typography;

const MOVIE_API = "https://backendexample.sanbersy.com/api/data-movie"
const GAME_API = "https://backendexample.sanbersy.com/api/data-game"

const Home = () => {
  let history = useHistory()
  const [movies, setMovies] = useState([])
  const [games, setGames] = useState([])
  const [trigger, setTrigger] = useState(true)

  useEffect(() => {
    if (trigger) {
      const getMovies = async () => {
        try {
          const movieResult = await axios.get(MOVIE_API)
          const gameResult = await axios.get(GAME_API)
          setMovies([...movieResult.data])
          setGames([...gameResult.data])
          setTrigger(false)
        } catch (err) {
          console.log(err)
        }
      }
      getMovies()
      setTrigger(false)
    }
  }, [trigger])

  const toDetailItem = (id, type = true) => {
    console.log(id)
    if (type) {
      history.push(`/detail/movie/${id}`)
    } else {
      history.push(`/detail/game/${id}`)
    }
  }
  
  return (
    <>
      <Content className="site-layout" style={{ padding: '0 50px', marginTop: 64 }}>
        <div className="site-layout-background" style={{ padding: 24, minHeight: 380 }}>
          <div className="title">
            <Title level={2}>Movies</Title>
            <Link to="/movies">
              See more movies  <ArrowRightOutlined />
            </Link>
          </div>
          <div id="movies" className="movies">
            {
              movies.map((el, index) => 
              index < 5 &&
                <div className="movie">
                  <Image
                    src={el.image_url}
                    preview={false}
                    height={"20em"}
                    width={"15em"}
                  />
                  <Link>
                    <h3 onClick={() => toDetailItem(el.id)} className="movie-title">{el.title}</h3>
                  </Link>
                </div>
              )
            }
          </div>
          <div className="title">
            <Title level={2}>Games</Title>
            <Link to="/games">
              See more games  <ArrowRightOutlined />
            </Link>
          </div>
          <div id="games" className="games">
            {
              games.map((el, index) => 
              index < 5 &&
                  <div className="game">
                    <Image
                      height={"20em"}
                      width={"15em"}
                      src={el.image_url}
                      preview={false}
                    />
                    <Link>
                      <h3 onClick={() => toDetailItem(el.id, false)} className="movie-title">{el.name}</h3>
                    </Link>
                  </div>
              )
            }
            </div>
        </div>
      </Content>
    </>
  )
}

export default Home